import React from 'react'
import { HStack, Text, Button } from '@chakra-ui/react'
import { RecommendationMethod } from '@/hooks/useTagRecommendations'

interface MethodSelectorProps {
  selectedMethod: RecommendationMethod
  onMethodChange: (method: RecommendationMethod) => void
  isDisabled?: boolean
}

const METHODS: { value: RecommendationMethod; label: string; color: string }[] = [
  { value: 'hybrid', label: 'hybrid', color: 'purple' },
  { value: 'embedding_similarity', label: 'embedding similarity', color: 'blue' },
  { value: 'text_similarity', label: 'text similarity', color: 'green' },
]

export function MethodSelector({
  selectedMethod,
  onMethodChange,
  isDisabled,
}: MethodSelectorProps) {
  const getMethodBadgeColor = (method: string) => {
    switch (method) {
      case 'hybrid':
        return 'purple'
      case 'embedding_similarity':
        return 'blue'
      case 'text_similarity':
        return 'green'
      default:
        return 'gray'
    }
  }

  return (
    <HStack spacing={2}>
      <Text fontSize="sm" fontWeight="medium">
        Method:
      </Text>
      {METHODS.map((method) => (
        <Button
          key={method.value}
          size="xs"
          variant={selectedMethod === method.value ? 'solid' : 'outline'}
          colorScheme={getMethodBadgeColor(method.value)}
          onClick={() => onMethodChange(method.value)}
          isDisabled={isDisabled}
        >
          {method.label}
        </Button>
      ))}
    </HStack>
  )
}
